export default __webpack_public_path__ + "static/media/first-peculiarity-bg.aaf2ccce.svg";